module.exports = __webpack_public_path__ + "img/Sibiu_Kran_kl.f287315b.jpg";